<template>
  <div>
    <b-modal id="modalEditRabbitMQServer" ref="modalEditRabbitMQServer"
      :title="$t('RabbitMQ Server')" hide-footer>
      <b-overlay :show="showOverlay" rounded="sm">
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID :" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.name" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col>
              <b-form-input v-model="editItem.host" />
            </b-col>
            <b-col>
              <b-form-input type="number" v-model.number="editItem.port" />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Exchange')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.exchange" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Routing key')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.routing_key" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Queue')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.queue" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.login" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.password" />
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="bvModal.hide('modalEditRabbitMQServer')"/>
      </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    showOverlay: false
  },
  methods: {
    save () {
      this.showOverlay = true
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_RABBIT_MQ_SERVERS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_RABBIT_MQ_SERVERS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RABBIT_MQ_SERVERS')
          this.$refs.modalEditRabbitMQServer.hide()
          this.$root.$emit('makeToasts')
        }
        this.showOverlay = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/rabbitMQ/editModal.vue